import styled from 'styled-components';

export const TableStyle = styled.table`
  margin-top: 20px;
  width: 100%;
  border-collapse: collapse;
  .text {
    font-size: ${({ theme }) => {
      return theme.fonts.size.superSmall;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    padding: 0 5px 0px 8px;
  }
  thead {
    text-align: left;
    tr {
      th {
        border-bottom: ${({ theme }) => {
          return theme.border;
        }};
        padding: 0 2.5px 5px 2.5px;
        font-size: ${({ theme }) => {
          return theme.fonts.size.normal;
        }};
        font-weight: ${({ theme }) => {
          return theme.fonts.weight.thin;
        }};
      }
    }
  }
`;
